import React from 'react';
import { Popup, Icon } from 'semantic-ui-react';

import classNames from 'classnames/bind';
import styles from './Help.css';
const cx = classNames.bind(styles);

const Help = ({ triggerProps, helpTitle, helpMessage, ...rest }) => {
  if (!triggerProps) {
    triggerProps = {};
  }
  return (
    <Popup
      hoverable
      basic
      size="small"
      trigger={
        <Icon
          name="help circle outline"
          color="grey"
          {...triggerProps}
          className={cx('help-popup-icon', triggerProps.className ? triggerProps.className : '')}
        />
      }
      position="right center"
      {...rest}
      className={cx('help-popup max-250', rest.className ? rest.className : '')}>
      {helpTitle && <Popup.Header className={cx('help-popup-header')}>{helpTitle}</Popup.Header>}
      <Popup.Content className={cx('help-popup-content')}>{helpMessage}</Popup.Content>
    </Popup>
  );
};

export default Help;



// WEBPACK FOOTER //
// ./src/script/components/common/Help.js